import { Box, Container, Flex, Text } from '@grupoboticario/flora-react'
import { CatalogNotFoundContent as content } from './CatalogNotFound.content'

export const CatalogNotFound = () => (
  <Flex
    align="center"
    justify="center"
    direction="column"
    css={{
      minHeight: 'calc(100vh - 43px)',
      textAlign: 'center',
      width: '100%',
    }}
  >
    <Container>
      <Box
        css={{
          maxWidth: 320,
          margin: '0 auto',
        }}
      >
        <Text
          size="bodyLargeStandardRegular"
          weight="heavy"
          as="h2"
          color="$backgroundAltPrimary"
        >
          {content.title}
        </Text>

        <Text
          size="exceptionsAuxiliarRegular"
          as="p"
        >
          {content.auxiliar}
        </Text>
      </Box>
    </Container>
  </Flex>
)
